import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";
import { Cookie, X } from "lucide-react";

const STORAGE_KEY = "gp_cookie_consent_v1";

export const CookieBanner = () => {
  const { lang } = useLang();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(STORAGE_KEY)) {
        const id = setTimeout(() => setVisible(true), 600);
        return () => clearTimeout(id);
      }
    } catch {
      setVisible(true);
    }
  }, []);

  const decide = (value) => {
    try { localStorage.setItem(STORAGE_KEY, value); } catch {}
    setVisible(false);
  };

  if (!visible) return null;

  const t = lang === "fr" ? {
    title: "Cookies & confidentialité",
    body: "Nous utilisons uniquement des cookies essentiels au fonctionnement du site (authentification, panier d'abonnement). Aucun cookie publicitaire.",
    accept: "J'ai compris",
    decline: "Refuser",
    more: "En savoir plus",
  } : {
    title: "Cookies & privacy",
    body: "We only use cookies strictly necessary to run the site (authentication, subscription cart). No advertising cookies.",
    accept: "Got it",
    decline: "Decline",
    more: "Learn more",
  };

  return (
    <div
      data-testid="cookie-banner"
      className="fixed left-3 right-3 md:left-6 md:right-auto md:max-w-md bottom-3 md:bottom-6 z-50 rounded-sm border border-[#C1A661]/40 bg-[#050B1E]/97 backdrop-blur-md p-5 shadow-2xl"
      style={{ paddingBottom: "calc(1.25rem + env(safe-area-inset-bottom, 0px))" }}
      role="dialog"
      aria-labelledby="cookie-banner-title"
    >
      <div className="flex items-start gap-3">
        <Cookie size={18} strokeWidth={1.4} className="text-[#C1A661] shrink-0 mt-0.5" />
        <div className="flex-1">
          <div id="cookie-banner-title" className="text-[11px] tracking-[0.25em] uppercase text-[#E2CFA4] font-medium">
            {t.title}
          </div>
          <p className="mt-2 text-[12px] text-[#A1A7B3] font-light leading-relaxed">
            {t.body}
          </p>
          <div className="mt-3 flex flex-wrap items-center gap-2">
            <button
              type="button"
              data-testid="cookie-accept-btn"
              onClick={() => decide("accepted")}
              className="px-4 py-2 rounded-full bg-[#C1A661] hover:bg-[#E2CFA4] text-[#050B1E] text-[10px] tracking-[0.25em] uppercase font-semibold transition-colors"
            >
              {t.accept}
            </button>
            <button
              type="button"
              data-testid="cookie-decline-btn"
              onClick={() => decide("declined")}
              className="px-4 py-2 rounded-full border border-[#C1A661]/40 hover:border-[#C1A661] text-[#E2CFA4] text-[10px] tracking-[0.25em] uppercase transition-colors"
            >
              {t.decline}
            </button>
            <Link
              to="/privacy"
              onClick={() => setVisible(false)}
              className="text-[10px] tracking-[0.2em] uppercase text-[#A1A7B3] hover:text-[#E2CFA4] transition-colors underline-offset-2 hover:underline"
            >
              {t.more}
            </Link>
          </div>
        </div>
        <button
          type="button"
          aria-label="close"
          onClick={() => decide("dismissed")}
          className="text-[#A1A7B3] hover:text-[#F8F5EE] transition-colors"
        >
          <X size={16} strokeWidth={1.4} />
        </button>
      </div>
    </div>
  );
};
